module.exports = __webpack_public_path__ + "img/new_tishi.629cb7e5.png";